import {IsBoolean, IsNumber} from 'class-validator';

export class UpdateCreditLackDto {
  @IsBoolean()
  isActive!: boolean;

  @IsNumber()
  threshold!: number;
}
